document.addEventListener('click', function (e) {
  var btn = e.target.closest('.qa-item__add-btn');
  if (!btn) return;

  btn.classList.add('loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function () { return fetch('/cart.js'); })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      btn.classList.remove('loading');
      btn.classList.add('added');
      setTimeout(function () { btn.classList.remove('added'); }, 1500);

      var count = cart.item_count;
      document.querySelectorAll('#cart-notification-count').forEach(function (el) {
        el.textContent = count;
      });
      document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
        var numEl = bubble.querySelector('[aria-hidden="true"]');
        if (numEl) numEl.textContent = count;
        bubble.style.display = count > 0 ? '' : 'none';
        bubble.classList.remove('qa-bubble-pop');
        void bubble.offsetWidth;
        bubble.classList.add('qa-bubble-pop');
        bubble.addEventListener('animationend', function () {
          bubble.classList.remove('qa-bubble-pop');
        }, { once: true });
      });
      document.querySelectorAll('.header__actions_btn--cart svg, .header__actions_btn--cart .icon-cart, .header__actions_btn--cart img').forEach(function (icon) {
        icon.classList.remove('qa-cart-bump');
        void icon.offsetWidth;
        icon.classList.add('qa-cart-bump');
        icon.addEventListener('animationend', function () {
          icon.classList.remove('qa-cart-bump');
        }, { once: true });
      });
    })
    .catch(function () {
      btn.classList.remove('loading');
    });
});
